"use strict";
/**
 * Created by rouven on 17.03.17.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.handleSubmit = exports.editEnd = exports.editStart = exports.changeLocation = exports.destroyFilter = exports.initializeFilter = exports.clearSelection = exports.changeSelection = exports.changeData = exports.destroyGrid = exports.initializeGrid = exports.changeSort = exports.changePageSize = exports.changePage = exports.applyFilter = void 0;
// @ts-ignore
var query_string_1 = __importDefault(require("query-string"));
var types = __importStar(require("./actionTypes"));
var wikom_data_1 = require("@wikom/wikom-data");
var changeGridParam = function (_a) {
    var name = _a.name, param = _a.param, value = _a.value;
    return function (replace, location) { return function (dispatch, getState) {
        var url = location.pathname;
        var queryParams = query_string_1["default"].parse(location.search);
        var gridParams = queryParams.grid ? JSON.parse(queryParams.grid) : {};
        if (!gridParams[name]) {
            gridParams[name] = {};
        }
        if (param === 'filter') {
            var visibleFields_1 = getState().form[name + 'Filter'].registeredFields || {};
            var indexableValue_1 = value;
            value = Object.assign.apply(Object, __spreadArray([{}], Object.keys(indexableValue_1)
                .filter(function (key) { return visibleFields_1.hasOwnProperty(key); })
                .map(function (key) {
                var _a;
                return (_a = {}, _a[key] = indexableValue_1[key], _a);
            }), false));
        }
        if (value === null) {
            delete gridParams[name][param];
        }
        else {
            gridParams[name][param] = value;
        }
        if (Object.keys(gridParams[name]).length === 0) {
            delete gridParams[name];
        }
        if (Object.keys(gridParams).length === 0) {
            delete queryParams.grid;
        }
        else {
            queryParams.grid = JSON.stringify(gridParams);
        }
        return replace({ pathname: url, search: query_string_1["default"].stringify(queryParams) });
    }; };
};
var applyFilter = function (data, name) { return changeGridParam({
    name: name,
    param: 'filter',
    value: data
}); };
exports.applyFilter = applyFilter;
var changePage = function (nextPage, name) { return changeGridParam({
    name: name,
    param: 'currentPage',
    value: nextPage + 1
}); };
exports.changePage = changePage;
var changePageSize = function (evt, name) { return changeGridParam({
    name: name,
    param: 'pageSize',
    value: Number(evt.target.value)
}); };
exports.changePageSize = changePageSize;
var changeSort = function (name, idx, asc) {
    if (asc === void 0) { asc = true; }
    return changeGridParam({
        name: name,
        param: 'sort',
        value: (asc ? '' : '-') + idx
    });
};
exports.changeSort = changeSort;
var initializeGrid = function (name) { return ({
    type: types.INITIALIZE,
    name: name
}); };
exports.initializeGrid = initializeGrid;
var destroyGrid = function (name) { return ({
    type: types.DESTROY,
    name: name
}); };
exports.destroyGrid = destroyGrid;
var changeData = function (name, data) { return ({
    type: types.DATA_CHANGED,
    name: name,
    data: data
}); };
exports.changeData = changeData;
var changeSelection = function (name, target) { return ({
    type: types.SELECTION_CHANGED,
    name: name,
    checked: target.checked,
    value: target.value
}); };
exports.changeSelection = changeSelection;
var clearSelection = function (name) { return ({
    type: types.SELECTION_CLEARED,
    name: name
}); };
exports.clearSelection = clearSelection;
var initializeFilter = function (name, initialValues) { return ({
    type: types.INITIALIZE_FILTER,
    name: name,
    initialValues: initialValues
}); };
exports.initializeFilter = initializeFilter;
var destroyFilter = function (name) { return ({
    type: types.DESTROY_FILTER,
    name: name
}); };
exports.destroyFilter = destroyFilter;
var changeLocation = function (location) { return ({
    type: types.LOCATION_CHANGED,
    payload: location
}); };
exports.changeLocation = changeLocation;
var editStart = function (name, rowId, colId) { return ({
    type: types.EDIT_START,
    name: name,
    rowId: rowId,
    colId: colId
}); };
exports.editStart = editStart;
var editEnd = function (name, rowId, colId) { return function (dispatch, getState) {
    var gridState = getState().grid[name].edit;
    var editEndFn = function () {
        if (rowId === gridState.rowId && colId === gridState.colId) {
            dispatch((0, exports.editStart)(name, null, null));
        }
    };
    setTimeout(editEndFn, 100);
}; };
exports.editEnd = editEnd;
var handleSubmit = function (values, grid, rowData, editRoute) { return function (dispatch, getState) {
    var allForms = getState().form;
    var editFormValues = Object.keys(allForms)
        .filter(function (formName) { return formName.indexOf('gridedit_' + grid) === 0; })
        .map(function (formName) { return allForms[formName].values; })
        .reduce(function (acc, cur) { return (__assign(__assign({}, acc), cur)); }, {});
    var data = __assign(__assign(__assign({}, rowData), editFormValues), values);
    //  @TODO: Fix type definition in wikom-data
    // @ts-ignore
    return dispatch((0, wikom_data_1.submit)({ url: editRoute, data: data }));
}; };
exports.handleSubmit = handleSubmit;
